import { render } from "./AlarmI18nSolutions.vue?vue&type=template&id=64de49c2&scoped=true"
import script from "./AlarmI18nSolutions.vue?vue&type=script&lang=js"
export * from "./AlarmI18nSolutions.vue?vue&type=script&lang=js"

import "./AlarmI18nSolutions.vue?vue&type=style&index=0&id=64de49c2&lang=scss&scoped=true"

import exportComponent from "/Users/breeze/data/code/src/gitlab.goiot.net/chargingc/cms/web2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64de49c2"]])

export default __exports__